import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Data Tools", -1)
const _hoisted_2 = { class: "bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden" }
const _hoisted_3 = { class: "grid grid-cols-2 p-5 space-x-2" }
const _hoisted_4 = { class: "column pr-2 border-r" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "border-b text-purple-400 font-bold pb-2" }, "For Data Extractors", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "Hero"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "The programmable web browser that's nearly impossible to block.")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "ChromeAlive"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "The interactive tool that makes writing scraper scripts pure joy.")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "Datastores"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "Package your data scripts as discrete, composable units ready to deploy.")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "Cloud"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "Easily run and scale your Datastores across production and localhost.")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "Domains"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "Currated data APIs that are ownable, managable and monetizable.")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "Manager"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "Create, optimize and debug your scripts across multiple envs")
], -1)
const _hoisted_12 = { class: "column" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "border-b text-purple-400 font-bold pb-2" }, "For Data Consumers", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "Stream"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "Integrate Ulixee's public and private datasets into your codebase.")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "Marketplace"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "Browse publicly available datasets from around the world.")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "Pipeline"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "Manage all your data consumption and billing from a simple UI.")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "px-5 py-5 bg-gray-50 space-y-6 sm:flex sm:space-y-0 sm:space-x-10 sm:px-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flow-root" }, "Install Ulixee.app")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_PopoverButton = _resolveComponent("PopoverButton")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NavItem = _resolveComponent("NavItem")!
  const _component_PopoverPanel = _resolveComponent("PopoverPanel")!
  const _component_Popover = _resolveComponent("Popover")!

  return (_openBlock(), _createBlock(_component_Popover, { class: "relative" }, {
    default: _withCtx(({ open }) => [
      _createVNode(_component_PopoverButton, {
        class: _normalizeClass([open ? 'text-gray-900' : 'text-purple-900', 'font-light group inline-flex items-center hover:text-gray-900 focus:outline-none focus:ring-0'])
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createTextVNode(),
          _createVNode(_component_ChevronDownIcon, {
            class: _normalizeClass([open ? 'text-gray-600 rotate-180' : 'text-purple-900', 'h-4 w-4 ml-1 stroke-1 duration-100 group-hover:text-gray-500']),
            "aria-hidden": "true"
          }, null, 8, ["class"])
        ]),
        _: 2
      }, 1032, ["class"]),
      _createTextVNode(),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-200",
        "enter-from-class": "opacity-0 translate-y-1",
        "enter-to-class": "opacity-100 translate-y-0",
        "leave-active-class": "transition ease-in duration-150",
        "leave-from-class": "opacity-100 translate-y-0",
        "leave-to-class": "opacity-0 translate-y-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_PopoverPanel, { class: "absolute z-10 left-0 transform mt-3 px-2 w-screen max-w-4xl sm:px-0" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createTextVNode(),
                    _createElementVNode("ul", null, [
                      _createVNode(_component_NavItem, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, { to: "/hero" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_inline_svg, {
                                src: require('@/assets/tool-icons/hero.svg')
                              }, null, 8, ["src"]),
                              _createTextVNode(),
                              _hoisted_6
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createTextVNode(),
                      _createVNode(_component_NavItem, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, { to: "/chromealive" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_inline_svg, {
                                src: require('@/assets/tool-icons/chromealive.svg')
                              }, null, 8, ["src"]),
                              _createTextVNode(),
                              _hoisted_7
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createTextVNode(),
                      _createVNode(_component_NavItem, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, { to: "/datastore" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_inline_svg, {
                                src: require('@/assets/tool-icons/datastore.svg')
                              }, null, 8, ["src"]),
                              _createTextVNode(),
                              _hoisted_8
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createTextVNode(),
                      _createVNode(_component_NavItem, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, { to: "/cloud" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_inline_svg, {
                                src: require('@/assets/tool-icons/server.svg')
                              }, null, 8, ["src"]),
                              _createTextVNode(),
                              _hoisted_9
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createTextVNode(),
                      _createVNode(_component_NavItem, { isComingSoon: true }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_inline_svg, {
                              src: require('@/assets/tool-icons/domain.svg')
                            }, null, 8, ["src"]),
                            _createTextVNode(),
                            _hoisted_10
                          ])
                        ]),
                        _: 1
                      }),
                      _createTextVNode(),
                      _createVNode(_component_NavItem, { isComingSoon: true }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_inline_svg, {
                              src: require('@/assets/tool-icons/manager.svg')
                            }, null, 8, ["src"]),
                            _createTextVNode(),
                            _hoisted_11
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createTextVNode(),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createTextVNode(),
                    _createElementVNode("ul", null, [
                      _createVNode(_component_NavItem, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, { to: "/stream" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_inline_svg, {
                                src: require('@/assets/tool-icons/stream.svg')
                              }, null, 8, ["src"]),
                              _createTextVNode(),
                              _hoisted_14
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createTextVNode(),
                      _createVNode(_component_NavItem, { isComingSoon: true }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_inline_svg, {
                              src: require('@/assets/tool-icons/marketplace.svg')
                            }, null, 8, ["src"]),
                            _createTextVNode(),
                            _hoisted_15
                          ])
                        ]),
                        _: 1
                      }),
                      _createTextVNode(),
                      _createVNode(_component_NavItem, { isComingSoon: true }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_inline_svg, {
                              src: require('@/assets/tool-icons/pipeline.svg')
                            }, null, 8, ["src"]),
                            _createTextVNode(),
                            _hoisted_16
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createTextVNode(),
                _hoisted_17
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}